import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/effem-logo.svg';
import BlueskyIcon from '../assets/bluesky-icon.svg';
import TangledIcon from '../assets/tangled-icon.svg';

const Footer = () => {
    const [year, setYear] = useState(new Date().getFullYear());

    useEffect(() => {
        setYear(new Date().getFullYear());
    } ,[]);

    return (
        <footer className="flex flex-col items-center gap-5 px-5 text-gray-600 dark:text-gray-500 border-t border-gray-300 dark:border-gray-700 py-14">
            <img src={logo} className="h-8 invert dark:invert-0 transition-all duration-300" alt="Effem Logo" />
            <div className="flex flex-wrap justify-center gap-16 m-10">
                <Link to="/about" className='transition-colors duration-300 hover:text-gray-900 dark:hover:text-white'>About</Link>
                <Link to="/developers" className='transition-colors duration-300 hover:text-gray-900 dark:hover:text-white'>Developers</Link>
                <Link to="/contact" className='transition-colors duration-300 hover:text-gray-900 dark:hover:text-white'>Contact</Link>
                <Link to="/privacy" className='transition-colors duration-300 hover:text-gray-900 dark:hover:text-white'>Privacy</Link>
                <a href="https://podcastindex.org" className='transition-colors duration-300 hover:text-gray-900 dark:hover:text-white' target="_blank" rel="noopener noreferrer">Podcast Index</a>
                <a href="https://atproto.com" target="_blank" rel="noopener noreferrer" className="transition-colors duration-300 hover:text-gray-900 dark:hover:text-white"> AT Protocol</a>
            </div>
            <div className="text-[12px]">
                Copyright &copy; {year} <a href="https://sparrowtek.com" target="_blank" rel="noopener noreferrer" className="transition-colors duration-300 hover:text-gray-900 dark:hover:text-white">SparrowTek LLC</a>. All rights reserved. Jersey City, NJ.
            </div>
            <div className="flex gap-5 mt-2">
                <a href="https://bsky.app/profile/sparrowtek.com" target="_blank" rel="noreferrer">
                    <img src={BlueskyIcon} className="h-5 invert dark:invert-0 transition-all duration-300 hover:scale-110" alt="Bluesky Icon" />
                </a>
                <a href="https://tangled.org/sparrowtek.com" target="_blank" rel="noreferrer">
                    <img src={TangledIcon} className="h-5 invert dark:invert-0 transition-all duration-300 hover:scale-110" alt="Tangled Icon" />
                </a>
            </div>
        </footer>
    );
}

export default Footer;
